var _path, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarWeek(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-9.53674e-07 3.0625C-9.53674e-07 2.35156 0.589286 1.75 1.28571 1.75H2.57143V0.328125C2.57143 0.164062 2.73214 0 2.89286 0H3.96428C4.15178 0 4.28571 0.164062 4.28571 0.328125V1.75H7.71429V0.328125C7.71429 0.164062 7.875 0 8.03571 0H9.10714C9.29464 0 9.42857 0.164062 9.42857 0.328125V1.75H10.7143C11.4375 1.75 12 2.35156 12 3.0625V12.6875C12 13.4258 11.4375 14 10.7143 14H1.28571C0.589286 14 -9.53674e-07 13.4258 -9.53674e-07 12.6875V3.0625ZM1.28571 12.5234C1.28571 12.6328 1.36607 12.6875 1.44643 12.6875H10.5536C10.6607 12.6875 10.7143 12.6328 10.7143 12.5234V4.375H1.28571V12.5234Z",
    fill: "#444444"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "iconHightligt",
    x: 2,
    y: 6,
    width: 2,
    height: 5,
    rx: 0.23,
    fill: "#444444"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 2,
    height: 5,
    rx: 0.23,
    fill: "#EFEFEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 2,
    height: 5,
    rx: 0.23,
    fill: "#EFEFEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWeek);
export default __webpack_public_path__ + "static/media/calendarWeek.ce1bc2fe.svg";
export { ForwardRef as ReactComponent };